export const FUTURE_DAYS = 14;